import { render, staticRenderFns } from "./enter-totp-verification-code.vue?vue&type=template&id=2e270ff1&scoped=true"
import script from "./enter-totp-verification-code.vue?vue&type=script&setup=true&lang=ts"
export * from "./enter-totp-verification-code.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./enter-totp-verification-code.vue?vue&type=style&index=0&id=2e270ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e270ff1",
  null
  
)

export default component.exports